import loaderClient from "api/reduxLoaderApi";
import { toast } from "react-toastify";
import { WIDGETS_BASE } from "../widgetConstants";
import { setWidgetList } from "./widgetsSlice";

export const getWidgets = (params) => async (dispatch) => {
  const query = params ? `?${params}` : "";
  const client = loaderClient("get")(`${WIDGETS_BASE}${query}`);
  const res = await client({})({});
  if (res.error) return toast.error(res.message);
  return dispatch(setWidgetList(res));
};

export const createWidget = (data, callback = false) => async () => {
  const client = loaderClient("post")(WIDGETS_BASE);
  const res = await client(data)({});
  if (res.error) return toast.error(res.message);
  toast.info("Create widget success");
  return callback && callback();
};

export const editWidget = (id, data, callback = false) => async () => {
  const client = loaderClient("patch")(`${WIDGETS_BASE}/${id}`);
  const res = await client(data)({});
  if (res.error) return toast.error(res.message);
  toast.info("Edit widget success");
  return callback && callback();
};

// DELETE returns 204 with no body
export const deleteWidget = (id, callback = false) => async () => {
  const client = loaderClient("delete")(`${WIDGETS_BASE}/${id}`);
  const res = await client({})({});
  if (res.error) return toast.error(res.message);
  toast.info("Delete widget success");
  return callback && callback();
};
